module.exports = __webpack_public_path__ + "img/Tick-green.fac37634.svg";